/**
 * B2B tenant group type for ScheduleAI (`user.client` / backend Client).
 * All analytics providers should map this to their account/organization/group API
 * (e.g. PostHog group analytics, Segment group, Amplitude account).
 */
export const ANALYTICS_GROUP_TYPE_COMPANY = 'company';
